// src/components/exam-player/renderers/NumericRenderer.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function NumericRenderer({
  item,
  onAnswerChange,
  initialAnswers,
  questionNumber,
  hideStem = false,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language?.includes("fa");

  const layout = item?.body?.layout || "top-bottom";
  const stemHtml = item?.stem?.fa || item?.stem?.en || "";

  // مقدار اولیه از attempt قبلی
  const getInitialValue = () => {
    const v = initialAnswers;
    if (v == null) return "";
    if (typeof v === "number") return String(v);
    if (typeof v === "string") return v;
    if (v && typeof v === "object") {
      const inner = v.value ?? v.answer;
      if (inner == null) return "";
      return String(inner);
    }
    return "";
  };

  const [value, setValue] = useState(getInitialValue);

  useEffect(() => {
    setValue(getInitialValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?._id]);

  const handleChange = (e) => {
    const v = e.target.value;
    setValue(v);

    if (!onAnswerChange) return;

    if (v === "") {
      onAnswerChange(null);
      return;
    }

    const n = Number(v);
    if (!Number.isNaN(n)) {
      onAnswerChange(n); // مقدار عددی
    } else {
      onAnswerChange(v); // اگر به هر دلیل عدد نشد، همون رشته
    }
  };

  const Stem = (
    <div
      dir={isRtl ? "rtl" : "ltr"}
      className="prose max-w-none text-gray-800 mb-3"
      dangerouslySetInnerHTML={{ __html: stemHtml }}
    />
  );

  const Input = (
    <div className="mt-2">
      <input
        type="number"
        step="any"
        className="border rounded-lg px-3 py-2 w-full max-w-xs"
        value={value}
        onChange={handleChange}
        placeholder={t("numeric.answer_placeholder", "Your answer")}
      />
    </div>
  );

  let content = null;

  if (layout === "left-right") {
    content = (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>{!hideStem && Stem}</div>
        <div>{Input}</div>
      </div>
    );
  } else if (layout === "right-left") {
    content = (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>{Input}</div>
        <div>{!hideStem && Stem}</div>
      </div>
    );
  } else if (layout === "bottom-top") {
    content = (
      <>
        {Input}
        {!hideStem && <div className="mt-4">{Stem}</div>}
      </>
    );
  } else {
    // top-bottom (default)
    content = (
      <>
        {!hideStem && Stem}
        {Input}
      </>
    );
  }

  return (
    <div className="rounded-lg bg-white p-4">
      {!hideStem && (
        <div className="text-xs text-gray-500 mb-2">
          {t("preview.question_n", "Question")} {questionNumber}
        </div>
      )}
      {content}
    </div>
  );
}
